import {useSelector} from "react-redux";
import {Space, Tag, Tooltip, Typography} from "antd";
import {stringMixin} from "../../../../utils/strings";
import OverflowSpace from "../../../../components/OverflowSpace";
import React from "react";

/**
 *
 * @param summaryDetails {Object} Summary details of the SMA
 * @param cutHoldings {Array[object]} Array of holdings in the cut SMA
 * @param fullHoldings {Array[object]} Array of all holdings in consolidated SMA
 * @param linkedPortfolio {Object, optional} The full portfolio object of the linked portfolio if it exists for the SMA
 * @returns {JSX.Element|null}
 * @constructor
 */
const SmaStatsBar = ({summaryDetails, cutHoldings, fullHoldings, linkedPortfolio=null})=>{
    const smaMode = useSelector(state=>state.sma.mode);

    if (!summaryDetails || !cutHoldings || !fullHoldings) return null;
    const sectorWeightChanges = summaryDetails?.sectorWeightChanges;
    const spaceConfig = [];
    if (sectorWeightChanges){
        for (let ticker in sectorWeightChanges){
            const change = sectorWeightChanges[ticker].percentChange;
            spaceConfig.push({
                label: `${ticker.toUpperCase()} ${(change*0.01).toFixed(1)}x`,
                key: ticker,
                value: change
            })
        }
        spaceConfig.sort((a, b)=>b.value - a.value);
    }


    return (
        <div style={{width: '100%'}}>
        <Space size={'large'} wrap={false}>
            <Space>
                Total Tickers  <Tag color={'magenta'} bordered={false}>{summaryDetails.totalHoldings}</Tag>
            </Space>
            <Space>
                Original Tickers  <Tag color={'magenta'} bordered={false}>{summaryDetails.originalHoldings}</Tag>
            </Space>
            <Space>
                Weight Filled  <Tag color={'magenta'} bordered={false}>{stringMixin.pct(summaryDetails.totalWeight)}</Tag>
            </Space>
            {linkedPortfolio && (
                <Space>
                    Linked Portfolio  <Typography.Link strong href={`/public/portfolio/${linkedPortfolio.id}`} target="_blank">{linkedPortfolio.name}</Typography.Link>
                </Space>
            )}
            {spaceConfig && smaMode==='advanced' && (
                <Space className={'px-3'}>
                    <Tooltip title={'%'}>
                        <Typography.Text strong>Refilled to Sectors</Typography.Text>

                    </Tooltip>
                    <OverflowSpace items={spaceConfig} color={'var(--blue)'} />

                </Space>
            )}
        </Space>
        </div>
    )

}


export default SmaStatsBar;
